<template>
    <div
        :id="id"
        class="transactionlink-graphic-image"
        :class="alignment"
    >
        <img
            :style="{ width: `${width}px`, height: `${height}px` }"
            :src="url"
            alt="graphic-image"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    url: String,
    options: Object,
})

const height = computed(() => props?.options?.height || 0)
const width = computed(() => props?.options?.width || 0)
const alignment = computed(() => props?.options?.alignment || '')

</script>

<style lang="sass" scoped>
@import "./GraphicImage.sass"
</style>
